module.exports = __webpack_public_path__ + "static/index/img/baikal-113.e9a77253.jpg";